module.exports = __webpack_public_path__ + "img/bg_losing.2b88cea7.png";